// export async function autoTranslate(text, targetLang) {
//   const res = await fetch(
//     `https://translate.googleapis.com/translate_a/single?client=gtx&sl=en&tl=${targetLang}&dt=t&q=${enco…
//   );
 
//   const data = await res.json();
//   return data[0][0][0];
// }
 
 
export async function autoTranslate(text, targetLang) {
 
  if (!text) return "";
 
  // limit per request
  const MAX = 400;
 
  const chunks = [];
 
  for (let i = 0; i < text.length; i += MAX) {
    chunks.push(text.slice(i, i + MAX));
  }
 
  const translatedChunks = await Promise.all(
    chunks.map(async (chunk) => {
 
      const res = await fetch(
        `https://translate.googleapis.com/translate_a/single?client=gtx&sl=en&tl=${targetLang}&dt=t&q=${encodeURIComponent(chunk)}`
      );
 
      const data = await res.json();
 
      return data[0][0][0];
    })
  );
 
  return translatedChunks.join(" ");
}